import qs from 'query-string';
import { get } from './baseApi';

export const VersionApi = {
    fetch: (query) => get(`/versions?${qs.stringify(query)}`),
};
